import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { formatINR, formatDate } from "../lib/format";

export default function ScheduleTable({ loanId }) {
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get(`/loans/${loanId}/schedule`).then((r) => setData(r.data));
    }, [loanId]);

    if (!data)
        return (
            <Card className="rounded-2xl border-slate-100 p-8 text-center text-sm text-slate-400">
                Loading…
            </Card>
        );
    const today = new Date().toISOString().slice(0, 10);

    return (
        <Card className="rounded-2xl border-slate-100 overflow-hidden">
            <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between flex-wrap gap-2">
                <div>
                    <div className="font-display text-sm font-bold text-slate-900">
                        Repayment Schedule
                    </div>
                    <div className="text-[11px] text-slate-500">
                        Interest auto-recalculates from outstanding principal after every approved payment.
                    </div>
                </div>
                <span
                    className="text-[10px] uppercase tracking-wider font-bold bg-blue-50 text-blue-900 px-2 py-1 rounded-md"
                    data-testid="schedule-info-badge"
                >
                    {data.tenure_months} months
                </span>
            </div>
            <div className="overflow-auto max-h-[60vh]">
                <table className="w-full text-sm">
                    <thead className="bg-slate-50 sticky top-0">
                        <tr>
                            {["#", "Due", "Outstanding", "Interest Due"].map((h) => (
                                <th
                                    key={h}
                                    className="text-left px-3 py-2 text-[11px] uppercase tracking-wider font-semibold text-slate-600"
                                >
                                    {h}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                        {data.schedule.map((s) => (
                            <tr
                                key={s.month}
                                data-testid={`sched-month-${s.month}`}
                                className={`hover:bg-slate-50 ${
                                    s.due_date < today ? "bg-amber-50/40" : ""
                                }`}
                            >
                                <td className="px-3 py-2 num text-slate-500">{s.month}</td>
                                <td className="px-3 py-2 text-slate-700 text-xs">{formatDate(s.due_date)}</td>
                                <td className="px-3 py-2 num">{formatINR(s.opening)}</td>
                                <td className="px-3 py-2 num font-semibold text-amber-700">
                                    {formatINR(s.interest)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Card>
    );
}
